'use strict';

import ReporteCSV from './csv/csv-general.module';
import ReporteGam from './reportesGam/repo-gam.module'

const Reporte = angular
    .module('app.reporte', [
        ReporteCSV,
        ReporteGam
    ])
    .name;

export default Reporte;



// WEBPACK FOOTER //
// ./src/app/components/reportes/reportes.module.js